import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker'
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import axios from 'axios';
import Swal from 'sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import es from "date-fns/locale/es";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
registerLocale('es', es);

const AddTrips = () => {
    const TripsTemplate = {
        branch_id: 0,
        branch_name: "Sucursal",
        schedule_id: 0,
        time: "00:00:00",
        letter_id: 0,
        driver_id: 0,
        unit_id: 0,
        link_trip: "NA"
    };
    const [trips, setTrips] = useState([TripsTemplate]);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [date_max, setDateMax] = useState(new Date());
    const [letters, setLetters] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [units, setUnits] = useState([]);
    const [role_id, setRoleId] = useState(0); // Nuevo estado para el rol
    const navigate = useNavigate();
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        // Obtener el rol del usuario
        const user = JSON.parse(localStorage.getItem('dataUser'));
        if (user) {
            setRoleId(user.rol_id);
        }
        
        const date = new Date();
        date.setDate(date.getDate() + 7);
        setDateMax(date);
        searchSchedules();
        var table = $('.main').DataTable();
        table.destroy();
        setTimeout(() => {
            $('.main').DataTable({
                searching: true,
                destroy: true,
                retrieve: true,
                pageLength: 50,
                responsive: true,
                autoWidth: true,
                paging: true,
                ordering: true,
                sortable: true,
                processing: false,
                serverSide: false,
                bInfo: true,
                language: {
                    "decimal": "",
                    "emptyTable": "",
                    "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                    "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                    "infoPostFix": "",
                    "thousands": ",",
                    "lengthMenu": "Mostrar _MENU_ registros",
                    "loadingRecords": "Cargando...",
                    "processing": "Procesando...",
                    "search": "Buscar:",
                    "paginate": {
                        "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                        "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                        "next": "<i className='fas fa-arrow-circle-right'></i>",
                        "previous": "<i className='fas fa-arrow-circle-left'></i>"
                    },
                    "zeroRecords": "No hay registros",
                    "searchPlaceholder": "Buscar por horario",
                },
            });
            setLoading(false);
        }, 100);
    }, []);

    // Update the change handler to handle both select and input fields
    $('.trip').on("change input", function (e) {
        const index = $(this).data('index');
        const updateTrips = trips.map((trip, i) =>
            index === i ? { ...trip, [e.target.name]: e.target.value } : trip
        );
        setTrips(updateTrips);
    });

    const getAllLetters = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-letters-trips');
        const lettersArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.letter_id,
            };
        })
        setLetters(lettersArray);
    };

    const getAllDrivers = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-drivers-trips');
        const driversArray = response.data.data.map(function (element) {
            return {
                label: element.name + ' ' + element.last_name,
                value: element.driver_id,
            };
        })
        setDrivers(driversArray);
    };

    const getAllUnits = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-units-trips');
        const unitsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.unit_id,
            };
        })
        setUnits(unitsArray);
    };

    const searchSchedules = async () => {
        setLoading(true);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const date_send = year + '-' + month + '-' + day;
        const form = new FormData();
        form.append('date', date_send);
        await axios.post(ENDPOINT + 'search-schedule-day', form)
            .then(response => {
                getAllLetters();
                getAllDrivers();
                getAllUnits();
                const tripsArray = response.data.data.map(function (element) {
                    return {
                        branch_id: element.branch_id,
                        branch_name: element.branch.name,
                        schedule_id: element.schedule_id,
                        time: element.time,
                        letter_id: 0,
                        driver_id: 0,
                        unit_id: 0,
                        link_trip: ""
                    };
                });
                setTrips(tripsArray);
                var table = $('.main').DataTable();
                table.destroy();
                setTimeout(() => {
                    $('.main').DataTable({
                        searching: true,
                        destroy: true,
                        retrieve: true,
                        pageLength: 50,
                        responsive: true,
                        autoWidth: true,
                        paging: true,
                        ordering: true,
                        sortable: true,
                        processing: false,
                        serverSide: false,
                        bInfo: true,
                        language: {
                            "decimal": "",
                            "emptyTable": "",
                            "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                            "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                            "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                            "infoPostFix": "",
                            "thousands": ",",
                            "lengthMenu": "Mostrar _MENU_ registros",
                            "loadingRecords": "Cargando...",
                            "processing": "Procesando...",
                            "search": "Buscar:",
                            "paginate": {
                                "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                                "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                                "next": "<i class='fas fa-arrow-circle-right'></i>",
                                "previous": "<i class='fas fa-arrow-circle-left'></i>"
                            },
                            "zeroRecords": "No hay registros",
                            "searchPlaceholder": "Buscar por horario",
                        },
                    });
                    setLoading(false);
                }, 100);
            }).catch(function (error) {
                setLoading(false);
                console.log(error)
            });
    }

    const handleSubmit = async () => {
        if (!trips || trips.length === 0) {
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">No hay viajes para guardar</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            return;
        }
        const form = new FormData();
        const dataForm = JSON.stringify(trips);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const dateFormat = year + '-' + month + '-' + day;
        form.append('date', dateFormat);
        form.append('data', dataForm);
        setLoading(true);
        await axios.post(ENDPOINT + 'save-trips-day', form).then(response => {
            setLoading(false);
            setTrips([TripsTemplate]);
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            navigate('/viajes');
        }).catch(function (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const resetPage = () => {
        setLoading(true);
        window.location.reload();
    };

    const formatTime = (timeString) => {
        if (!timeString) return "";
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        const hours12 = (date.getHours() % 12) || 12;
        const formattedHours12 = hours12.toString().padStart(2, '0');
        return `${formattedHours12}:${formattedMinutes} ${ampm}`;
    };

    return (
        <>
            {loading && <Loader />}
            <div className="container-fluid">
                <ContentHeader title="Módulo de Viajes"/>
            </div>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-map	me-2"></i> Agregar Viajes
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <Link
                                    to="/viajes"
                                    type="buttom"
                                    className="btn btn-secondary btn-sm me-1">
                                    <i className="fa-solid fa-list me-1"></i> Listado de Viajes
                                </Link>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="indications row align-items-center">
                            <div className="col-lg-7">
                                <div className="add-trips-card search-controls bg-light p-4 rounded-3 shadow-sm h-100">
                                    <div className="add-trips-card-body">
                                        <div className="mb-4">
                                            <h6 className="text-muted mb-3">
                                                <i className="fas fa-info-circle me-2"></i>
                                                Seleccione una fecha para programar los viajes
                                            </h6>
                                        </div>
                                        <div className="row align-items-end">
                                            <div className="col-md-7 mb-3 mb-md-0">
                                                <label htmlFor="date" className="form-label fw-bold mb-2">
                                                    <i className="far fa-calendar-alt me-2"></i>
                                                    Fecha de Viajes
                                                </label>
                                                <div className="input-group">
                                                    <DatePicker
                                                        showIcon
                                                        locale="es"
                                                        selected={date}
                                                        onChange={(date) => setDate(date)}
                                                        maxDate={role_id === 1 ? null : date_max} // Solo para superadmin (rol_id = 1) sin límite máximo
                                                        minDate={role_id === 1 ? null : new Date()} // Solo para superadmin (rol_id = 1) sin límite mínimo
                                                        className="form-control form-control-sm"
                                                        dateFormat="dd, MMMM, yyyy"
                                                        placeholderText="Seleccionar fecha..."
                                                    />
                                                </div>
                                                <small className="text-muted mt-1 d-block">
                                                    {role_id === 1 
                                                        ? 'Superadmin: Puede seleccionar cualquier fecha' 
                                                        : 'La información mostrada corresponderá a la fecha seleccionada (máximo 7 días futuros)'}
                                                </small>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="d-grid gap-2">
                                                    <button
                                                        onClick={searchSchedules}
                                                        className="btn btn-primary btn-sm d-flex align-items-center justify-content-center py-2">
                                                        <i className="fa fa-search me-2"></i> Buscar
                                                    </button>
                                                    <button
                                                        onClick={handleSubmit}
                                                        className="btn btn-success btn-sm d-flex align-items-center justify-content-center py-2">
                                                        <i className="fa-solid fa-floppy-disk me-2"></i> Guardar Viajes
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="add-trips-summary h-100 text-white p-4 rounded-3 shadow position-relative overflow-hidden">
                                    <div className="add-trips-card-body position-relative z-1">
                                        <h6 className="text-white-50 mb-3">Total de horarios encontrados</h6>
                                        <h2 className="display-4 fw-bold mb-0">
                                            {trips.length}
                                        </h2>
                                        <p className="mb-0 mt-2 text-white-50">
                                            <i className="fas fa-calendar-day me-1"></i> 
                                            {date.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                                        </p>
                                    </div>
                                    <div className="position-absolute bottom-0 end-0 p-4 opacity-25">
                                        <i className="fas fa-route" style={{ fontSize: '5rem' }}></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-2">
                            <table className="table table-hover main table-striped">
                                <thead>
                                    <tr>
                                        <th width="10%" className="text-center">Sucursal</th>
                                        <th width="10%" className="text-center">Horario</th>
                                        <th width="10%" className="text-center">Letra</th>
                                        <th width="20%" className="text-center">Conductor</th>
                                        <th width="20%" className="text-center">Unidad</th>
                                        <th width="30%" className="text-center">Link de Seguimiento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {trips.map((value, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        id="branch_id"
                                                        name="branch_id"
                                                        type="hidden"
                                                        value={value.branch_id}
                                                    />
                                                    <span className="pt-2">{value.branch_name}</span>
                                                </td>
                                                <td className="text-center">
                                                    <input
                                                        id="schedule_id"
                                                        name="schedule_id"
                                                        type="hidden"
                                                        value={value.schedule_id}
                                                    />
                                                    <span className="pt-2">{formatTime(value.time)}</span>
                                                </td>
                                                <td>
                                                    <select
                                                        className="form-control form-control-sm select2 trip"
                                                        id="letter_id"
                                                        name="letter_id"
                                                        data-index={index}
                                                    >
                                                        <option selected value="0">Seleccione</option>
                                                        {letters.map((item, index) => (
                                                            <option key={index} value={item.value}>{item.label}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>
                                                    <select
                                                        className="form-control form-control-sm select2 trip"
                                                        id="driver_id"
                                                        name="driver_id"
                                                        data-index={index}
                                                    >
                                                        <option selected value="0">Seleccione</option>
                                                        {drivers.map((item, index) => (
                                                            <option key={index} value={item.value}>{item.label}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>
                                                    <select
                                                        className="form-control form-control-sm select2 trip"
                                                        id="unit_id"
                                                        name="unit_id"
                                                        data-index={index}
                                                    >
                                                        <option selected value="0">Seleccione</option>
                                                        {units.map((item, index) => (
                                                            <option key={index} value={item.value}>{item.label}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control form-control-sm trip"
                                                        id="link_trip"
                                                        name="link_trip"
                                                        type="text"
                                                        placeholder="Ingrese link de seguimiento"
                                                        data-index={index}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddTrips;